exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#about{display:-webkit-box;display:-ms-flexbox;display:flex;flex-flow:row wrap;justify-content:center}#about .title{width:100%;text-align:center}#about .wrapper{justify-content:flex-start}@media (min-width:600px){#about .wrapper{width:80%;margin:10px auto 0}}#about .wrapper h2{width:100%}#about .wrapper p{color:#263238;margin:3px 0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-601659a8","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/about.vue
// module id = 51
// module chunks = 0